import InputOption from './input-option';
import { IInputOption } from './interfaces';

export type { IInputOption };
export default InputOption;